<template>
  <div class="dialog" id="export-shopping-list-dialog" aria-hidden="true">
    <div
      class="dialog-overlay"
      tabindex="-1"
      data-a11y-dialog-hide
      @click="closeModal"
    ></div>
    <div
      role="dialog"
      class="dialog-content"
      aria-labelledby="my-dialog-title"
      aria-describedby="my-dialog-description"
    >
      <section class="pdf" v-if="props.list">
        <header class="list__header">
          <div class="list__header-left">
            <div class="list__logo">
              <img src="@/assets/icons/shopping-list.svg" alt="" />
            </div>
            <div class="list__info">
              <h2 class="list__title">Eksportuj produkty do PDF</h2>
            </div>
          </div>
          <div class="list__header-right">
            <div class="list__prices">
              <span class="list__total">{{ $t("list.summary") }}</span>
              <span class="list__total-price">{{
                currency(sumsWithCurrencies.PLN)
              }}</span>
              <template v-if="sumsWithCurrencies.GBP">
                <span></span>
                <span class="list__total-price">{{
                  currency(sumsWithCurrencies.GBP, "GBP")
                }}</span>
              </template>
              <template v-if="sumsWithCurrencies.USD">
                <span></span>
                <span class="list__total-price">{{
                  currency(sumsWithCurrencies.USD, "USD")
                }}</span>
              </template>
              <template v-if="sumsWithCurrencies.EUR">
                <span></span>
                <span class="list__total-price">{{
                  currency(sumsWithCurrencies.EUR, "EUR")
                }}</span>
              </template>
              <span class="list__provision">{{ $t("list.provision") }}</span>
              <span class="list__provision-price">{{
                currency(list.commission)
              }}</span>
            </div>
          </div>
        </header>

        <div class="room" v-for="room in props.list.shoppingListRooms">
          <div class="room__bar-fill"></div>
          <div class="room__header">
            <div class="room__title">
              <h3>{{ room.name }}</h3>
              <span>{{ room.shoppingListRoomProducts.length }}</span>
            </div>
          </div>
          <div class="room__bar"></div>
          <div>
            <div
              class="furniture"
              v-for="furn in room.shoppingListRoomProducts"
            >
              <div class="export__checkbox">
                <input
                  type="checkbox"
                  :checked="checkedItems[furn.id]"
                  @change="checkedItems[furn.id] = !checkedItems[furn.id]"
                />
              </div>
              <ProductImageCarousel
                :images="furn.shoppingListProductImages"
                empty-message="Brak zdjęcia"
              />
              <div class="furniture__content">
                <div class="furniture__wrapper">
                  <div class="furniture__base">
                    <h4 class="furniture__title">{{ furn.name }}</h4>
                    <div class="furniture__status-info">
                      <span class="furniture__id">ID {{ furn.id }}</span>
                      <span class="furniture__status" v-if="furn.status"
                        >{{ $t("list.status_" + furn.status.toLowerCase()) }}
                      </span>
                    </div>
                    <p class="furniture__producer">
                      {{ $t("list.vendor") }} <span>{{ furn.vendor }}</span>
                    </p>
                    <p class="furniture__date">
                      Termin realizacji:
                      <span v-if="furn.completionDate">
                        {{ moment(furn.completionDate).format("DD/MM/YYYY") }}
                      </span>
                    </p>
                    <div class="furniture__favourites">
                      <a
                        v-if="furn.link"
                        class="furniture__link"
                        :href="
                          furn.link.startsWith('http')
                            ? furn.link
                            : '//' + furn.link
                        "
                        target="_blank"
                      >
                        <svg
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.50841 7.4916C5.79674 7.76587 5.79674 8.21596 5.50841 8.49023C5.23414 8.7645 4.78405 8.7645 4.50978 8.49023C3.85109 7.83055 3.48113 6.93643 3.48113 6.00421C3.48113 5.07199 3.85109 4.17787 4.50978 3.51819L6.99931 1.02866C7.65899 0.369971 8.55311 7.62939e-06 9.48533 7.62939e-06C10.4176 7.62939e-06 11.3117 0.369971 11.9714 1.02866C12.63 1.68833 13 2.58245 13 3.51468C13 4.4469 12.63 5.34102 11.9714 6.00069L10.9235 7.04855C10.9305 6.47188 10.8391 5.89521 10.6422 5.34666L10.9727 5.0091C11.1699 4.81408 11.3264 4.58189 11.4332 4.32598C11.54 4.07006 11.595 3.7955 11.595 3.51819C11.595 3.24088 11.54 2.96632 11.4332 2.71041C11.3264 2.45449 11.1699 2.22231 10.9727 2.02728C10.7777 1.83013 10.5455 1.67362 10.2896 1.5668C10.0337 1.45999 9.75913 1.40499 9.48182 1.40499C9.2045 1.40499 8.92995 1.45999 8.67403 1.5668C8.41812 1.67362 8.18593 1.83013 7.99091 2.02728L5.50841 4.50979C5.31126 4.70481 5.15474 4.937 5.04793 5.19291C4.94111 5.44882 4.88611 5.72338 4.88611 6.00069C4.88611 6.27801 4.94111 6.55256 5.04793 6.80848C5.15474 7.06439 5.31126 7.29658 5.50841 7.4916ZM7.49159 4.50979C7.76586 4.23552 8.21595 4.23552 8.49022 4.50979C9.14891 5.16946 9.51887 6.06358 9.51887 6.9958C9.51887 7.92803 9.14891 8.82215 8.49022 9.48182L6.00069 11.9714C5.34101 12.63 4.44689 13 3.51467 13C2.58245 13 1.68833 12.63 1.02865 11.9714C0.369963 11.3117 0 10.4176 0 9.48534C0 8.55312 0.369963 7.659 1.02865 6.99932L2.07651 5.95147C2.06947 6.52814 2.1609 7.10481 2.35781 7.66038L2.02728 7.99092C1.83013 8.18594 1.67361 8.41813 1.5668 8.67404C1.45998 8.92995 1.40498 9.20451 1.40498 9.48182C1.40498 9.75914 1.45998 10.0337 1.5668 10.2896C1.67361 10.5455 1.83013 10.7777 2.02728 10.9727C2.2223 11.1699 2.45449 11.3264 2.7104 11.4332C2.96631 11.54 3.24087 11.595 3.51818 11.595C3.7955 11.595 4.07006 11.54 4.32597 11.4332C4.58188 11.3264 4.81407 11.1699 5.00909 10.9727L7.49159 8.49023C7.68874 8.29521 7.84526 8.06302 7.95208 7.80711C8.05889 7.55119 8.11389 7.27663 8.11389 6.99932C8.11389 6.72201 8.05889 6.44745 7.95208 6.19154C7.84526 5.93562 7.68874 5.70344 7.49159 5.50841C7.42329 5.44441 7.36885 5.36708 7.33163 5.28119C7.29441 5.19531 7.27521 5.1027 7.27521 5.0091C7.27521 4.9155 7.29441 4.82289 7.33163 4.73701C7.36885 4.65112 7.42329 4.57379 7.49159 4.50979Z"
                            fill="#468CDE"
                          />
                        </svg>
                        {{ furn.link }}
                      </a>
                    </div>
                  </div>
                  <div class="furniture__info">
                    <span>{{ $t("list.amount") }}</span>
                    <span>{{ furn.amount }}</span>
                    <span>{{ $t("list.price_unit") }}</span>
                    <span>{{ currency(furn.price, furn.currency) }}</span>
                    <span>{{ $t("list.sum") }}</span>
                    <span>{{
                      currency(furn.amount * furn.price, furn.currency)
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="footer">
        <div class="footer__info">
          <div class="footer__icon">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.33268 7.75002H8.16602C8.40213 7.75002 8.60018 7.67002 8.76018 7.51002C8.92018 7.35002 8.99991 7.15224 8.99935 6.91669V6.08335C8.99935 5.84724 8.91935 5.64919 8.75935 5.48919C8.59935 5.32919 8.40157 5.24947 8.16602 5.25002H6.91602C6.80491 5.25002 6.70768 5.29169 6.62435 5.37502C6.54102 5.45835 6.49935 5.55558 6.49935 5.66669V9.00002C6.49935 9.11113 6.54102 9.20835 6.62435 9.29169C6.70768 9.37502 6.80491 9.41669 6.91602 9.41669C7.02713 9.41669 7.12435 9.37502 7.20768 9.29169C7.29102 9.20835 7.33268 9.11113 7.33268 9.00002V7.75002ZM7.33268 6.91669V6.08335H8.16602V6.91669H7.33268ZM11.4993 9.41669C11.7355 9.41669 11.9335 9.33669 12.0935 9.17669C12.2535 9.01669 12.3332 8.81891 12.3327 8.58335V6.08335C12.3327 5.84724 12.2527 5.64919 12.0927 5.48919C11.9327 5.32919 11.7349 5.24947 11.4993 5.25002H10.2493C10.1382 5.25002 10.041 5.29169 9.95768 5.37502C9.87435 5.45835 9.83268 5.55558 9.83268 5.66669V9.00002C9.83268 9.11113 9.87435 9.20835 9.95768 9.29169C10.041 9.37502 10.1382 9.41669 10.2493 9.41669H11.4993ZM10.666 8.58335V6.08335H11.4993V8.58335H10.666ZM13.9993 7.75002H14.416C14.5271 7.75002 14.6243 7.70835 14.7077 7.62502C14.791 7.54169 14.8327 7.44447 14.8327 7.33335C14.8327 7.22224 14.791 7.12502 14.7077 7.04169C14.6243 6.95835 14.5271 6.91669 14.416 6.91669H13.9993V6.08335H14.416C14.5271 6.08335 14.6243 6.04169 14.7077 5.95835C14.791 5.87502 14.8327 5.7778 14.8327 5.66669C14.8327 5.55558 14.791 5.45835 14.7077 5.37502C14.6243 5.29169 14.5271 5.25002 14.416 5.25002H13.5827C13.4716 5.25002 13.3743 5.29169 13.291 5.37502C13.2077 5.45835 13.166 5.55558 13.166 5.66669V9.00002C13.166 9.11113 13.2077 9.20835 13.291 9.29169C13.3743 9.37502 13.4716 9.41669 13.5827 9.41669C13.6938 9.41669 13.791 9.37502 13.8743 9.29169C13.9577 9.20835 13.9993 9.11113 13.9993 9.00002V7.75002ZM5.66602 14C5.20768 14 4.81518 13.8367 4.48852 13.51C4.16185 13.1834 3.99879 12.7911 3.99935 12.3334V2.33335C3.99935 1.87502 4.16268 1.48252 4.48935 1.15585C4.81602 0.829188 5.20824 0.666133 5.66602 0.666688H15.666C16.1243 0.666688 16.5168 0.830022 16.8435 1.15669C17.1702 1.48336 17.3332 1.87558 17.3327 2.33335V12.3334C17.3327 12.7917 17.1693 13.1842 16.8427 13.5109C16.516 13.8375 16.1238 14.0006 15.666 14H5.66602ZM5.66602 12.3334H15.666V2.33335H5.66602V12.3334ZM2.33268 17.3334C1.87435 17.3334 1.48185 17.17 1.15518 16.8434C0.828517 16.5167 0.665461 16.1245 0.666017 15.6667V4.83335C0.666017 4.59724 0.746017 4.39919 0.906017 4.23919C1.06602 4.07919 1.26379 3.99947 1.49935 4.00002C1.73546 4.00002 1.93352 4.08002 2.09352 4.24002C2.25352 4.40002 2.33324 4.5978 2.33268 4.83335V15.6667H13.166C13.4021 15.6667 13.6002 15.7467 13.7602 15.9067C13.9202 16.0667 13.9999 16.2645 13.9993 16.5C13.9993 16.7361 13.9193 16.9342 13.7593 17.0942C13.5993 17.2542 13.4016 17.3339 13.166 17.3334H2.33268Z"
                fill="#498388"
              />
            </svg>
          </div>
          <h2 class="footer__title">
            Eksportuj zaznaczone produkty {{ productCount }}
          </h2>
        </div>
        <div class="footer__actions">
          <button @click="closeModal" class="footer__btn footer__btn-outline">
            Anuluj
          </button>
          <button @click="onExport" class="footer__btn">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.33268 7.75002H8.16602C8.40213 7.75002 8.60018 7.67002 8.76018 7.51002C8.92018 7.35002 8.99991 7.15224 8.99935 6.91669V6.08335C8.99935 5.84724 8.91935 5.64919 8.75935 5.48919C8.59935 5.32919 8.40157 5.24947 8.16602 5.25002H6.91602C6.80491 5.25002 6.70768 5.29169 6.62435 5.37502C6.54102 5.45835 6.49935 5.55558 6.49935 5.66669V9.00002C6.49935 9.11113 6.54102 9.20835 6.62435 9.29169C6.70768 9.37502 6.80491 9.41669 6.91602 9.41669C7.02713 9.41669 7.12435 9.37502 7.20768 9.29169C7.29102 9.20835 7.33268 9.11113 7.33268 9.00002V7.75002ZM7.33268 6.91669V6.08335H8.16602V6.91669H7.33268ZM11.4993 9.41669C11.7355 9.41669 11.9335 9.33669 12.0935 9.17669C12.2535 9.01669 12.3332 8.81891 12.3327 8.58335V6.08335C12.3327 5.84724 12.2527 5.64919 12.0927 5.48919C11.9327 5.32919 11.7349 5.24947 11.4993 5.25002H10.2493C10.1382 5.25002 10.041 5.29169 9.95768 5.37502C9.87435 5.45835 9.83268 5.55558 9.83268 5.66669V9.00002C9.83268 9.11113 9.87435 9.20835 9.95768 9.29169C10.041 9.37502 10.1382 9.41669 10.2493 9.41669H11.4993ZM10.666 8.58335V6.08335H11.4993V8.58335H10.666ZM13.9993 7.75002H14.416C14.5271 7.75002 14.6243 7.70835 14.7077 7.62502C14.791 7.54169 14.8327 7.44447 14.8327 7.33335C14.8327 7.22224 14.791 7.12502 14.7077 7.04169C14.6243 6.95835 14.5271 6.91669 14.416 6.91669H13.9993V6.08335H14.416C14.5271 6.08335 14.6243 6.04169 14.7077 5.95835C14.791 5.87502 14.8327 5.7778 14.8327 5.66669C14.8327 5.55558 14.791 5.45835 14.7077 5.37502C14.6243 5.29169 14.5271 5.25002 14.416 5.25002H13.5827C13.4716 5.25002 13.3743 5.29169 13.291 5.37502C13.2077 5.45835 13.166 5.55558 13.166 5.66669V9.00002C13.166 9.11113 13.2077 9.20835 13.291 9.29169C13.3743 9.37502 13.4716 9.41669 13.5827 9.41669C13.6938 9.41669 13.791 9.37502 13.8743 9.29169C13.9577 9.20835 13.9993 9.11113 13.9993 9.00002V7.75002ZM5.66602 14C5.20768 14 4.81518 13.8367 4.48852 13.51C4.16185 13.1834 3.99879 12.7911 3.99935 12.3334V2.33335C3.99935 1.87502 4.16268 1.48252 4.48935 1.15585C4.81602 0.829188 5.20824 0.666133 5.66602 0.666688H15.666C16.1243 0.666688 16.5168 0.830022 16.8435 1.15669C17.1702 1.48336 17.3332 1.87558 17.3327 2.33335V12.3334C17.3327 12.7917 17.1693 13.1842 16.8427 13.5109C16.516 13.8375 16.1238 14.0006 15.666 14H5.66602ZM5.66602 12.3334H15.666V2.33335H5.66602V12.3334ZM2.33268 17.3334C1.87435 17.3334 1.48185 17.17 1.15518 16.8434C0.828517 16.5167 0.665461 16.1245 0.666017 15.6667V4.83335C0.666017 4.59724 0.746017 4.39919 0.906017 4.23919C1.06602 4.07919 1.26379 3.99947 1.49935 4.00002C1.73546 4.00002 1.93352 4.08002 2.09352 4.24002C2.25352 4.40002 2.33324 4.5978 2.33268 4.83335V15.6667H13.166C13.4021 15.6667 13.6002 15.7467 13.7602 15.9067C13.9202 16.0667 13.9999 16.2645 13.9993 16.5C13.9993 16.7361 13.9193 16.9342 13.7593 17.0942C13.5993 17.2542 13.4016 17.3339 13.166 17.3334H2.33268Z"
                fill="currentColor"
              />
            </svg>
            Eksportuj PDF
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, inject } from "vue";
import { currency } from "@/helpsers/currency.helper";
import moment from "moment";
import ProductImageCarousel from "./ProductImageCarousel.vue";
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";
import AlertHelper from "@/helpsers/alert.helper";

const modal = ref();
onMounted(() => {
  modal.value = new A11yDialog(
    document.querySelector("#export-shopping-list-dialog")
  );
});
const props = defineProps(["projectInfo", "list"]);
const emit = defineEmits(["close"]);

const checkedItems = ref({});
watch(
  () => props.list,
  (listValue) => {
    if (!listValue) {
      checkedItems.value = {};
      return;
    }
    const allProducts = [];
    for (const room of props.list.shoppingListRooms) {
      for (const product of room.shoppingListRoomProducts) {
        allProducts.push(product);
      }
    }
    checkedItems.value = allProducts.reduce((acc, val) => {
      acc[val.id] = true;
      return acc;
    }, {});
  }
);
const productCount = computed(() => {
  let count = 0;
  for (const value of Object.values(checkedItems.value)) {
    if (value) {
      count++;
    }
  }
  return count;
});

function showModal() {
  modal.value?.show();
}
defineExpose({ showModal });
function closeModal() {
  modal.value?.hide();
  emit("close");
}

let alert = inject("alert");
async function onExport() {
  try {
    if (!productCount.value) {
      AlertHelper.show(alert, "Wybierz 1 produkt do eksportu", "", "error");
      return;
    }
    const productsIds = [];
    for (const [key, value] of Object.entries(checkedItems.value)) {
      if (value) {
        productsIds.push(Number(key));
      }
    }
    const res = await axios.post(
      ApiHelper.exportShoppingListUrl(props.projectInfo.id, props.list.id),
      { productsIds: productsIds },
      { headers: authHelper.authHeader(), responseType: "blob" }
    );
    window.open(URL.createObjectURL(res.data));
    // modal.value?.hide();
  } catch (error) {
    AlertHelper.show(alert, "Błąd eksportowania pdf", "", "error");
  }
}

/** @type {import('vue').ComputedRef<{PLN: number; EUR: number; USD: number; GBP: number}>} */
const sumsWithCurrencies = computed(() => {
  if (!props.list) {
    return {
      PLN: 0,
      EUR: 0,
      USD: 0,
      GBP: 0,
    };
  }

  const allProducts = [];
  for (const room of props.list.shoppingListRooms) {
    for (const product of room.shoppingListRoomProducts) {
      allProducts.push(product);
    }
  }
  const sumMap = allProducts.reduce(
    (acc, value) => {
      acc[value.currency] += value.price * value.amount;
      return acc;
    },
    {
      PLN: 0,
      EUR: 0,
      USD: 0,
      GBP: 0,
    }
  );
  return sumMap;
});
</script>

<style scoped lang="scss">
@use "@/css/shopping-list.scss";
@use "@/css/shopping-list-header.scss";
@use "@/css/shopping-list-room.scss";
@use "@/css/shopping-list-product.scss";

.dialog-content {
  max-width: min(1200px, 95%);
  width: 100%;
  height: 100%;
}
.pdf {
  height: calc(100% - 52px - 10px);
  overflow-y: auto;
}
.export__checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
  input {
    appearance: none;
    margin: 0 15px 0 0;
    outline: none;
    &::after {
      box-sizing: border-box;
      content: "";
      display: block;
      width: 24px;
      height: 24px;
      border-radius: 6px;
      border: 2px solid #00000061;
    }
    &:checked {
      &::after {
        background-color: #498388;
        border: 0;
        background-image: url("@/assets/icons/checkmark.svg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 50%;
      }
    }
  }
}

.footer {
  height: 52px;
  margin-top: 10px;
  padding: 0 20px;
  background: #eef4f4;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
}
.footer__info {
  display: flex;
  align-items: center;
}
.footer__icon {
  background: #ffffff;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer__title {
  font-weight: 500;
  font-size: 18px;
  color: #498388;
  margin-left: 16px;
}
.footer__actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.footer__btn {
  background: #498388;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  font-size: 12px;
  height: 32px;
  padding: 0 2rem;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  cursor: pointer;
  transition: all 300ms;
  &:hover {
    opacity: 0.8;
  }
}
.footer__btn-outline {
  color: #498388;
  background-color: #ffffff;
  border: 1px solid #498388;
}
</style>
